import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useRootStore } from 'stores/RootStore'
import { DocMenu } from './DocMenu'
import { MovePanel } from './MovePanel'
import { DocMenuContainerProps } from './Types'

export const DocMenuContainer = observer(
  ({ id, onAction, dismiss, onMoveAction, onMoveSuccess, ...rest }: DocMenuContainerProps) => {
    const [showMove, setShowMove] = useState(false)
    const { files } = useRootStore()
    const file = files.get(id)

    useEffect(() => {
      files.fetch(id)
    }, [id, files])

    if (!file) {
      return null
    }

    if (showMove) {
      return <MovePanel file={file} dismiss={dismiss} onSuccess={onMoveSuccess} />
    }

    return (
      <DocMenu
        {...rest}
        article={{ almanac_file: file }}
        onAction={(action) => {
          if (action === 'move') {
            setShowMove(true)
            onMoveAction?.(() => setShowMove(false))
            return
          }
          onAction?.(action)
        }}
      />
    )
  },
)
